//トップページ
export function homeFunc() {
  const loading = document.querySelector(".c-loading");
  const header = document.querySelector(".l-header");
  const fvSection = document.querySelector(".p-top__fv");
  
  // ローディング処理
  setTimeout(() => {
    loading.classList.add("loaded");
    
    // ローディング完了後にアニメーションを実行
    setTimeout(() => {
      const fvBg = document.querySelector(".p-top__fv__bg");
      const fvImage = document.querySelector(".p-top__fv__image");
      
      // bgのアニメーション開始
      if (fvBg) {
        fvBg.classList.add("loaded");
      }
      
      // imageのアニメーションをbgの完了後に開始
      setTimeout(() => {
        if (fvImage) {
          fvImage.classList.add("loaded");
        }
      }, 500); // bgのアニメーション完了後（0.6s + 0.2s余裕）
    }, 200);
  }, 2000);
  
  // ヘッダーの表示制御（PCのみ）
  if (header && fvSection) {
    // PCかどうかを判定する関数
    const isPC = () => window.innerWidth > 768;
    
    // 初期状態でSPの場合はヘッダーを常に表示
    if (!isPC()) {
      header.classList.remove("is-hidden");
      return;
    }
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // fvセクションが見えている時はヘッダーを非表示
          header.classList.add("is-hidden");
        } else {
          // fvセクションが見えなくなったらヘッダーを表示
          header.classList.remove("is-hidden");
        }
      });
    }, {
      threshold: 0.1, // 10%見えたら判定
      rootMargin: "0px 0px -10% 0px" // 下から10%の位置で判定
    });
    
    observer.observe(fvSection);
    
    // リサイズ時の処理
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!isPC()) {
          // SPになった場合はヘッダーを常に表示
          header.classList.remove("is-hidden");
          observer.disconnect();
        } else {
          // PCになった場合は再度監視を開始
          observer.observe(fvSection);
        }
      }, 100);
    });
  }
}
